module.exports = __webpack_public_path__ + "static/media/4.bea93765.jpg";